import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mastodon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M433 179.1c0 0 0.8 71.7-9 121.5-6.2 31.6-55.1 66.2-111.2 72.9-20.1 2.4-93.1 14.2-178.8-6.7v0.3c0 3.8 0.4 9.8 0.9 13.6 6.6 49.6 49.2 52.6 89.6 54 40.8 1.3 77.1-10.1 77.1-10.1l1.7 36.9s-28.5 15.3-79.3 18.1c-28 1.6-62.8-0.7-103.3-11.4-112.2-29.7-105.6-173.4-105.6-289.1 0-97.2 63.7-125.7 63.7-125.7 61.9-28.4 228-28.7 290.5 0 0 0 63.7 28.5 63.7 125.7zM357.9 304.3c0-122 5.3-147.7-18.4-175-25.7-28.7-79.7-31-103.8 6.1l-11.6 19.5-11.6-19.5c-24-36.9-77.9-35-103.8-6.1-23.6 27.1-18.4 52.9-18.4 175h46.7v-114.2c0-49.7 64-51.6 64 6.9v62.5h46.3v-62.5c0-58.5 64-56.6 64-6.9v114.2h46.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/mastodon.js
// module id = 768
// module chunks = 0